(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mac-editorial-hero"] && !Shopify.designMode) return;
  try {
    
  if (!window.macEditorialRevealReady) {
    window.macEditorialRevealReady = true;
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('mac-is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    const observeSections = () => document.querySelectorAll('.mac-reveal:not(.mac-is-visible)').forEach((section) => observer.observe(section));
    observeSections();
    document.addEventListener('shopify:section:load', observeSections);
  }
  const mountMacEditorialHeaderCta = () => {
    document.querySelectorAll('[data-mac-editorial-header-cta]').forEach((element) => element.remove());
    const source = document.querySelector('.mac-editorial-header-cta-source');
    const actions = document.querySelector('header-component .header__column--right');
    if (!source || !actions) return;
    const button = source.cloneNode(true);
    button.className = 'mac-editorial-header-cta';
    button.dataset.macEditorialHeaderCta = 'true';
    actions.prepend(button);
  };
  mountMacEditorialHeaderCta();
  document.addEventListener('shopify:section:load', mountMacEditorialHeaderCta);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
